export default __webpack_public_path__ + "static/media/hoiRed.b04fe089.svg";